module.exports = __webpack_public_path__ + "img/07_hair.1c4780b7.png";